import PropTypes from 'prop-types';

export const HtmlElementItemPropType = PropTypes.shape({
  name: PropTypes.string,
  enabled: PropTypes.bool,
  domLocation: PropTypes.string,
  websiteLocation: PropTypes.string,
});
